import { Input } from "@equidefi/ui";
import { PatternFormat } from "react-number-format";

type MfaCodeInputProps = {
  value?: string | null;
  onChange: (value: string) => void;
} & Record<string, unknown>;

export const MfaCodeInput = ({ value, onChange, ...props }: MfaCodeInputProps) => (
  <Input
    as={PatternFormat}
    name="mfa_code"
    format="######"
    mask="_"
    placeholder="0 0 0 0 0 0"
    value={value}
    onValueChange={({ value: code }: { value: string }) => onChange(code)}
    autoComplete="off"
    autoFocus
    h="12"
    textAlign="center"
    mb="3"
    {...props}
  />
);
